export default "__VITE_ASSET__D97eE7rc__"